import React, { FC, memo } from 'react'
import { DeleteFileCallback, FileWithPreview } from 'LibNeo'
import { FileWrapperItem } from './styled'
import { FileItemComponent } from './FileItem.component'

interface UploadPreviewProps {
	fileList?: FileWithPreview[]
	deleteFile: DeleteFileCallback
	fixWidth?: boolean
	loading?: boolean
	noAutoUpload?: boolean
	className?: string
}

export const UploadPreviewComponent: FC<UploadPreviewProps> = memo(
	({ fileList, deleteFile, fixWidth, loading, noAutoUpload = false, className }) => {
		if (!fileList || !fileList.length) return null

		return (
			<FileWrapperItem fixWidth={fixWidth} className={className}>
				{fileList.reverse().map((file, index) => (
					<FileItemComponent
						// eslint-disable-next-line react/no-array-index-key
						key={`${String(file.name)}_${index}`}
						file={file}
						index={index}
						deleteFile={deleteFile}
						isError={Boolean(file.error)}
						loading={loading}
						noAutoUpload={noAutoUpload}
					/>
				))}
			</FileWrapperItem>
		)
	}
)
